import React from 'react'
import { DotLoading } from 'antd-mobile-v5'
import { FormattedMessage } from 'react-intl'

const InfiniteScrollContent = ({ hasMore, failed, onRetry }) => {
  // InfiniteScroll 的 loadMore reject 后进入 failed 状态，点击链接走其自带 retry 逻辑
  if (failed) {
    return (
      <span>
        <span className="adm-infinite-scroll-failed-text">
          <FormattedMessage id="common-load-failed" />
        </span>
        <button
          type="button"
          style={{ background: 'none', border: 'none', color: '#108ee9', padding: 0 }}
          onClick={() => onRetry && onRetry()}
        >
          <FormattedMessage id="common-retry" />
        </button>
      </span>
    )
  }
  if (!hasMore) {
    return (
      <span>
        <FormattedMessage id="common-load-no-more" />
      </span>
    )
  }
  return (
    <>
      <span>
        <FormattedMessage id="common-loading" />
      </span>
      <DotLoading />
    </>
  )
}

export default InfiniteScrollContent
